import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ChildComponentMixin extends Vue {
  private initChildComponentMixinCalled = false;
  childComponentName: string | null = null;
  index = 0;

  initChildComponentMixin (
    childComponentName: string,
  ): void {
    this.initChildComponentMixinCalled = true;
    this.childComponentName = childComponentName;
  }

  mounted () {
    this.$nextTick(() => {
      this.dispatchItemMountedEvent();
    });
  }

  private dispatchItemMountedEvent () {
    if (!this.initChildComponentMixinCalled) {
      // eslint-disable-next-line no-console
      console.error('ChildComponentMixin not correctly initialized yet! Please add initChildComponentMixin() call in the created() method of your child component.');
    }
    const event = new CustomEvent(`childComponentMounted_${this.childComponentName}`, {
      bubbles: true,
      composed: true,
      detail: {
        item: this,
      },
    });
    this.$el.dispatchEvent(event);
  }
}
